import VueElementLoading from 'vue-element-loading';
import Papa from "papaparse";
import Util from './../../../shared/util/util';




export default {
  name: 'basicinformation',
  components: {  
    VueElementLoading
  },
  props:['selectedEditRow','clientlogs'],
  data() {
    return {
      contractlog : this.selectedEditRow,
      clientapprovallogs: this.clientlogs
    }
  },
  computed: {},
  mounted() {

  },
  methods: {
    downloadLogs(){
      try {
        this.isLoading = true;
        let result= [];
        if (this.contractlog.length > 1) {
          for (let index = 0; index < this.contractlog.length; index++) {
            let tempObj = {
              "Log number": this.contractlog[index].count,
              "Date" :this.contractlog[index].createddate,
              "Changes Made" :this.contractlog[index].changesmade,
              "Changes Made by" :this.contractlog[index].createdby,
              "Reason" :this.contractlog[index].changereason,
            }
            result.push(tempObj)
            
          }
           var blob = new Blob([Papa.unparse(result)], { type: 'text/csv;charset=utf-8;' });
           var link = document.createElement("a");
           var url = URL.createObjectURL(blob);
           link.setAttribute("href", url);
           link.setAttribute("download", 'ClientContractLog.csv');
           link.style.visibility = 'hidden';
           document.body.appendChild(link);
           link.click();
           document.body.removeChild(link);
           this.isLoading = false;
        }else{
          this.$alertify.error("No Data Found");
        }
       
      } catch (error) {
        console.log(error)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientContractLog/clientcontractlog.component.js